/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Button, Typography } from '@mui/material';
import { usePayments, useStripeCheckout } from 'hooks';
import { CardDetails, BankDetails } from 'components/elements';
import Styles from './styles';
import StripeInfoContainer from './StripeInfoContainer';

const useStyles = makeStyles(Styles);

export default function PaymentSettings() {
  const classes = useStyles(Styles);
  const [paymentMethod, setpaymentMethod] = useState({});
  const { t } = useTranslation('labels');
  const { data } = usePayments();
  const { data: link, isSuccess: isLinkSuccess } = useStripeCheckout();

  useEffect(() => {
    if (!data) return;
    const { name, isDefault, paymentType } = data.data.attributes;
    if (name != null && document.getElementById('cardNotificationBox') != null) {
      window.location.reload();
    }
    setpaymentMethod({ ...data.data.attributes.acssDebit, ...data.data.attributes.card, name, isDefault, paymentType });
  }, [data]);

  let paymentMethodDetail;

  if (paymentMethod.paymentType === 'card') {
    paymentMethodDetail = <CardDetails {...paymentMethod} />;
  } else if (paymentMethod.paymentType === 'acss_debit') {
    paymentMethodDetail = <BankDetails {...paymentMethod} />;
  } else {
    paymentMethodDetail = (
      <Typography className={classes.noCardsText} color="text.secondary" variant="body2" component="div">
        {t('no_payment_methods_available')}
      </Typography>
    );
  }

  return (
    <div className={classes.paymentSettingsWrapper}>
      <Typography sx={{ fontWeight: 'bold' }} color="text.primary" variant="h4" component="div" gutterBottom>
        {t('payment_methods')}
      </Typography>
      {paymentMethodDetail}
      <Button className={classes.addButton} variant="contained" disabled={!isLinkSuccess} href={link?.url} color="primary">
        + {t('add_payment_method')}
      </Button>
      <StripeInfoContainer />
    </div>
  );
}
